





























import { CanalLead, CanalLeadService } from "@/services/canal-lead.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import ManterCanalProspeccao from "../modals/ManterCanalProspeccao.vue";

interface ComboItem {
  text: string;
  value: string | null;
}

@Component({
  components: {
    ManterCanalProspeccao,
  },
})
export default class ComboCanalLead extends Vue {
  @Prop() readonly value!: string | null;
  @Prop() readonly comNovoCanal!: boolean | false;
  @Prop({ required: true }) readonly label!: string;
  @Prop() readonly rules: Array<(v: any) => string | undefined> | undefined;
  loading = false;
  canalLead: ComboItem | null = null;
  itemsCanalLead: ComboItem[] = [];

  @Watch("value", { immediate: true })
  onValueChange(val: string | null) {
    val = "" + val;
    this.canalLead = this.itemsCanalLead.find((x) => x.value == val) ?? null;
  }

  @Watch("canalLead")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  onCanalCadastro(canalLead: CanalLead) {
    this.fetchCanalLead().then(() => {
      this.canalLead = this.itemsCanalLead.find(
        (_) => _.value == canalLead.idCanalLead.toString()
      )!;
    });
  }

  abrirCadastro() {
    const cadastroLead = this.$refs.cadastroLead as ManterCanalProspeccao;
    cadastroLead.abrirModal();
  }

  async fetchCanalLead() {
    this.loading = true;
    const res = await CanalLeadService.obterCanalLead();
    this.itemsCanalLead = [
      { value: "", text: "" },
      ...res.map((x) => ({
        text: x.nome,
        value: "" + x.idCanalLead,
      })),
    ];

    if (this.value) {
      this.canalLead =
        this.itemsCanalLead.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchCanalLead();
  }
}
